/**
 * The participant app's English catalog — kept apart from the dashboard's so a phone
 * on conference Wi-Fi downloads only the strings it shows (apps/join has a 100 KB
 * budget).
 */
export const joinEn = {
  "brand.name": "Buzzly",
  "join.title": "Join a session",
  "join.codeLabel": "Enter the code on screen",
  "join.codePlaceholder": "1234 5678",
  "join.continue": "Continue",
  "join.checking": "Checking…",
  "join.notFound": "We couldn't find an open session with that code.",
  "join.nameLabel": "Your name",
  "join.nameHintOptional": "Shown on the leaderboard. You can leave it blank.",
  "join.nameHintRequired": "Shown on the leaderboard.",
  "join.join": "Join",
  "join.joining": "Joining…",
  "join.error": "Something went wrong. Please try again.",
  "join.tooMany": "Too many tries from this network. Wait a few minutes, then try again.",
  "join.full": "This session is full. The presenter can make room for more.",
  "join.nameRefused": "That name can't be shown on screen. Please choose a different one.",
  "join.changeCode": "Use a different code",
  "join.notice": "The organiser sees your name and your answers.",
  "join.privacy": "Privacy policy",

  "live.connecting": "Connecting…",
  "live.reconnecting": "Reconnecting…",
  "live.lobby.title": "You're in!",
  "live.lobby.named": "You're in, {name}!",
  "live.lobby.body": "Watch the screen. Questions will appear here.",
  "live.getReady": "Get ready to answer…",
  "live.answersIn": "Read the question — answers in {seconds}…",
  "live.secondsLeft": "{seconds}s",
  "live.submit": "Send",
  "live.sending": "Sending…",
  "live.sent": "Answer sent!",
  "live.sentWait": "Wait for the results on screen.",
  "live.closed": "Time's up",
  "live.closedBody": "Answers are closed. Results are coming.",
  "live.missed": "You didn't answer this one.",
  "live.correct": "Correct!",
  "live.incorrect": "Not this time",
  "live.pickSeveral": "Pick all that apply, then send.",
  "live.answerWas": "The answer: {answer}",
  "live.points": "+{points} points",
  "live.results": "Results",
  "live.wordsPlaceholder": "Word {n}",
  "live.textPlaceholder": "Type your answer",
  "live.invalid": "That answer can't be accepted: {reason}",
  "live.score": "{score} pts",
  "live.rank": "#{rank}",
  "live.average": "Average {value}",
  "live.react": "Send a reaction to the screen",
  "live.reaction.like": "Thumbs up",
  "live.reaction.love": "Love it",
  "live.reaction.laugh": "Funny",
  "live.reaction.clap": "Applause",
  "live.reaction.party": "Celebrate",
  "live.reaction.wow": "Wow",

  "qna.tab": "Questions",
  "qna.back": "Back to the session",
  "qna.title": "Ask the presenter",
  "qna.placeholder": "Type your question",
  "qna.anonymous": "Ask anonymously",
  "qna.ask": "Send question",
  "qna.asking": "Sending…",
  "qna.sentModerated": "Sent! It will appear once the presenter approves it.",
  "qna.sent": "Sent!",
  "qna.empty": "No questions yet. Be the first!",
  "qna.off": "Questions are switched off for this session.",
  "qna.tooMany": "You've asked the most questions allowed in this session.",
  "qna.upvote": "Upvote",
  "qna.upvoted": "Upvoted",
  "qna.votes.one": "{count} vote",
  "qna.votes.other": "{count} votes",
  "qna.answered": "Answered",
  "qna.anonymousAuthor": "Anonymous",

  "ended.title": "Thanks for taking part!",
  "final.title": "Hall of fame",
  "final.watch": "Look at the screen!",
  "final.waiting": "Your place is coming up…",
  "final.winner": "You won!",
  "final.place.one": "{rank}st place",
  "final.place.two": "{rank}nd place",
  "final.place.few": "{rank}rd place",
  "final.place.other": "{rank}th place",
  "final.podium": "You made the podium!",
  "final.points": "{score} points",
  "final.noScore": "No points this time. Thanks for playing!",
  "final.claim": "Your claim code",
  "final.claim.hint": "If you've won a prize, show this to the organiser. Take a screenshot to keep it.",
  "ended.gone": "This session has ended or is no longer available.",
  "ended.removed": "The presenter has removed you from this session.",

  "remote.badge": "Remote",
  "remote.pairing": "Connecting to the console…",
  "remote.unpaired.title": "Scan the code on the console",
  "remote.unpaired.body": "On your laptop, open the session and choose Phone remote, then scan the code with this phone's camera.",
  "remote.expired": "That code has expired or was already used. Show a new one on the console.",
  "remote.slideOf": "Slide {number} of {count}",
  "remote.lobby": "Lobby: waiting to start",
  "remote.participants.one": "{count} joined",
  "remote.participants.other": "{count} joined",
  "remote.onScreen.leaderboard": "The leaderboard is on screen",
  "remote.onScreen.podium": "The hall of fame is on screen",
  "remote.answered": "{answered} of {count} answered",
  "remote.answersClosed": "Answers closed",
  "remote.nextUp": "Next up",
  "remote.next.start": "Start the session",
  "remote.next.open": "Open answers",
  "remote.next.reading": "Answers open in {seconds}s",
  "remote.next.close": "Stop answers and show results",
  "remote.next.closeAndNext": "Stop answers, next slide",
  "remote.next.leaderboard": "Show leaderboard",
  "remote.next.slide": "Next slide",
  "remote.next.podium": "Show the hall of fame",
  "remote.next.closeAndPodium": "Stop answers, show the hall of fame",
  "remote.next.finish": "End the session",
  "remote.failed": "That didn't work. Try again.",
  "remote.qna.pending": "Waiting for approval",
  "remote.qna.approve": "Approve",
  "remote.qna.reject": "Hide",
  "remote.ended": "The session has ended. You can close this page.",
  "ended.again": "Join another session",

  "paced.progress": "{n} of {total}",
  "paced.closes": "Open until {date}",
  "paced.next": "Next",
  "paced.skip": "Skip",
  "paced.saved": "Saved",
  "paced.timeUp": "Time's up",
  "paced.timeUpBody": "Moving on to the next one…",
  "paced.done.title": "All done!",
  "paced.done.body": "Your answers are in. Thanks for taking part.",
  "paced.closed": "This session has closed, so it no longer takes answers.",
} as const;

export type JoinMessageKey = keyof typeof joinEn;
export type JoinCatalog = Record<JoinMessageKey, string>;
